var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9882 6.08386C18.0666 6.00549 18.1738 5.956 18.2976 5.956L23.3051 5.956C23.5443 5.956 23.7423 6.15399 23.7423 6.39322L23.7423 11.4007C23.7423 11.64 23.5443 11.8379 23.3051 11.8379C23.0658 11.8379 22.8678 11.64 22.8678 11.4007L22.8678 6.83045L18.2976 6.83045C18.0583 6.83045 17.8604 6.63246 17.8604 6.39322C17.8562 6.27361 17.9098 6.16224 17.9882 6.08386Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9835 13.096L22.9256 6.15402C23.0947 5.9849 23.3752 5.9849 23.5443 6.15402C23.7134 6.32314 23.7134 6.60362 23.5443 6.77274L16.6023 13.7148C16.4331 13.8839 16.1527 13.8839 15.9835 13.7148C15.8144 13.5456 15.8144 13.2652 15.9835 13.096Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7103 23.6144C11.6319 23.6927 11.5247 23.7422 11.4009 23.7422L6.39341 23.7422C6.15418 23.7422 5.95619 23.5443 5.95619 23.305L5.95619 18.2975C5.95619 18.0583 6.15418 17.8603 6.39341 17.8603C6.63265 17.8603 6.83064 18.0583 6.83064 18.2975L6.83064 22.8678L11.4009 22.8678C11.6401 22.8678 11.8381 23.0658 11.8381 23.305C11.8423 23.4246 11.7886 23.536 11.7103 23.6144Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7149 16.6022L6.77293 23.5442C6.60381 23.7133 6.32332 23.7133 6.15421 23.5442C5.98509 23.3751 5.98509 23.0946 6.15421 22.9255L13.0962 15.9835C13.2653 15.8144 13.5458 15.8144 13.7149 15.9835C13.8841 16.1526 13.8841 16.4331 13.7149 16.6022Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.c61d263655f55fc5497f07349858b523.svg";
export { ForwardRef as ReactComponent };